import { Address } from "@styleguide";
import { type Control, Controller, useWatch } from "react-hook-form";
import type { TModalSocialOfferFormResolver } from "../logics/resolver";

interface IModalSocialOfferFormFieldAddressProps {
  control: Control<TModalSocialOfferFormResolver>;
}

export const ModalSocialOfferFormFieldAddress = ({ control }: IModalSocialOfferFormFieldAddressProps) => {
  const isRemote = useWatch({ control, name: "isRemote" });

  return (
    <Controller
      control={control}
      name="address"
      render={({ field: { value, onChange }, fieldState: { error }, formState: { errors } }) => (
        <Address
          label={`Lieu d'accueil${isRemote ? "" : " *"}`}
          value={value}
          onChange={(_, value) => onChange(value)}
          fullWidth
          size="small"
          TextFieldProps={{
            error: !!error,
            helperText: error?.message ?? errors?.address?.loc?.message,
          }}
        />
      )}
    />
  );
};
